import { ENDPOINTS } from '@/api/endpoints'
import type { CurrentUserResponse } from '@/api/types/user'

import { sliceApi } from './api'

export const userSliceApi = sliceApi
  .enhanceEndpoints({
    addTagTypes: ['User'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUser: builder.query<CurrentUserResponse, void>({
        query: () => ENDPOINTS.USER(),
        providesTags: ['User'],
      }),
    }),
    overrideExisting: false,
  })

export const { useGetUserQuery } = userSliceApi
